import { Component, Prop, h, Element, Host, Watch } from '@stencil/core';
import state from './pn-profile-modal-store';
@Component({
  tag: 'pn-profile-modal-type',
  styleUrl: 'pn-profile-modal-type.scss',
})
export class PnProfileModalType {
  @Element() hostElement: Element;

  @Prop({ reflect: true }) typeid: string = '';
  @Prop({ mutable: true }) name: string = 'false';
  @Prop({ mutable: true }) selected: boolean = false;
  @Prop({ mutable: true }) selectedprofile: string = null;

  @Watch('selected')
  onSelectedChange() {
    if (this.selected) {
      state.selectedType = this.name;
    }
    state.selectedProfile = '';
    [...this.hostElement.querySelectorAll('pn-profile-modal-profile')].map(x => {
      x.setAttribute('selected', 'false');
    });
  }
  render() {
    return (
      <Host selected={(state.selectedType === this.name) + ''} selected-profile={state.selectedProfile + ''}>
        <slot />
      </Host>
    );
  }
}
